export const generatedRuntimeDependencyCustodyLedger = {
  "schemaVersion": 1,
  "generatedAt": "2026-07-01T00:00:00.000Z",
  "mode": "deterministic-runtime-dependency-custody-ledger",
  "operatingRule": "Runtime dependency custody is an acquisition and reproducibility layer. It turns local preflight blockers into reviewed setup evidence requirements without promoting science claims.",
  "sidecarReadinessLedgerHash": "sha256-7a4b373db0f893ddd30084d8eaffcd2096c429821481b6079022e3e960ffb1c8",
  "sidecarRunSpecPacketHash": "sha256-ce4ff5977802635c5e8c813974453dba222a297a374ab09f9e58d7d61b843d3e",
  "contractCount": 5,
  "readyForRuntimeGenerationCount": 2,
  "blockedDependencyCustodyCount": 3,
  "missingDependencyCount": 5,
  "blockerClassCounts": {
    "system-runtime": 1,
    "input-custody": 1,
    "build-artifact": 1,
    "external-application": 1,
    "python-package": 1
  },
  "platformDependencyCustodyReady": false,
  "customerUseAllowed": false,
  "commercialUseAllowed": false,
  "dependencyRecords": [
    {
      "contractId": "spice-gf-event-window-v1",
      "tool": "NASA NAIF SPICE Geometry Finder",
      "domain": "ephemeris-event-windows",
      "sourceIds": [
        "spice-gf"
      ],
      "sourceRefs": [
        {
          "sourceId": "spice-gf",
          "title": "SPICE Geometry Finder",
          "organization": "NASA NAIF",
          "type": "official software standard",
          "url": "https://naif.jpl.nasa.gov/pub/naif/toolkit_docs/C/req/gf.html",
          "trust": "primary",
          "supports": "Geometry-event windows, angular separation, occultation, distance constraints."
        }
      ],
      "readinessState": "runtime-artifact-promoted",
      "reproducibilityState": "promoted-artifact-currently-reproducible",
      "latestPreflightCanReproduce": true,
      "bestPreflightCanReproduce": true,
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "ready-to-run-runtime-worker",
        "blockedProbeIds": [],
        "passedProbeIds": [
          "python-runtime",
          "spice-worker-script",
          "python-module-spiceypy",
          "spice-kernel-manifest"
        ]
      },
      "installEvidenceRequired": [
        "SPICE Toolkit or SpiceyPy version",
        "kernel manifest checksums"
      ],
      "runSpecHash": "sha256-a416865942c7d332b206a4cebcfc9068c9006dbf4222dc7dbc26437a2b986f4c",
      "requiredOutputPath": "artifacts/sidecars/spice-gf-event-window-v1.json",
      "commandTemplate": "python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json",
      "dependencyCount": 4,
      "passedDependencyCount": 4,
      "missingDependencyCount": 0,
      "dependencyStateCounts": {
        "present-in-current-preflight": 4
      },
      "blockerClassCounts": {},
      "dependencyItems": [
        {
          "contractId": "spice-gf-event-window-v1",
          "probeId": "python-runtime",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm python-runtime remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-b44826536a5379322634d10ca1ab039f22280c431ac94667e82a5cb5d38d10b9"
        },
        {
          "contractId": "spice-gf-event-window-v1",
          "probeId": "spice-worker-script",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm spice-worker-script remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-b199fd8e1aa10c19c0c28485539e4347c61191e832b4b8d3c53529fa4792927d"
        },
        {
          "contractId": "spice-gf-event-window-v1",
          "probeId": "python-module-spiceypy",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm python-module-spiceypy remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-d846ad165985b532c757e66c130aad42a694752653bf6febc4e4aa490fb9e317"
        },
        {
          "contractId": "spice-gf-event-window-v1",
          "probeId": "spice-kernel-manifest",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm spice-kernel-manifest remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-adedc7d963c26e323ca391d154825f555ed967dca4f2fb55c2b8f80246849663"
        }
      ],
      "acquisitionPriority": 4,
      "acquisitionState": "ready-for-runtime-artifact-generation",
      "nextAction": "Run python sidecars/spice_gf/run_spice_gf.py --scenario <scenarioId> --kernel-manifest <kernelManifest.json> --constraints <constraints.json> --out artifacts/sidecars/spice-gf-event-window-v1.json and validate the output through sidecar intake.",
      "evidenceBoundary": "Dependency custody records make runtime setup reproducible. They are not model outputs and cannot promote scenario, trajectory, resource, economics, customer, or commercial claims.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "dependencyRecordHash": "sha256-62d13abcfed835c2a7df334090dfff654faad4743eb27d46f9beec51b6b08f9c"
    },
    {
      "contractId": "orekit-propagation-v1",
      "tool": "Orekit",
      "domain": "trajectory-propagation",
      "sourceIds": [
        "orekit"
      ],
      "sourceRefs": [
        {
          "sourceId": "orekit",
          "title": "Orekit",
          "organization": "CS Group / open source community",
          "type": "open-source astrodynamics library",
          "url": "https://www.orekit.org/",
          "trust": "open-source",
          "supports": "Future propagation, event detection, frames, time scales, and orbit analysis."
        }
      ],
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-input-custody",
        "blockedProbeIds": [
          "java-runtime",
          "orekit-data-path",
          "orekit-sidecar-jar"
        ],
        "passedProbeIds": []
      },
      "installEvidenceRequired": [
        "Orekit version",
        "orekit-data archive hash",
        "JVM version"
      ],
      "runSpecHash": "sha256-6760d4cf3d986ffb70f72246168ab2562bc9b35b7dc40400d0cba01b759d29dd",
      "requiredOutputPath": "artifacts/sidecars/orekit-propagation-v1.json",
      "commandTemplate": "java -jar sidecars/orekit/build/libs/orekit-sidecar.jar --scenario <scenarioId> --data-context <orekit-data.zip> --out artifacts/sidecars/orekit-propagation-v1.json",
      "dependencyCount": 3,
      "passedDependencyCount": 0,
      "missingDependencyCount": 3,
      "dependencyStateCounts": {
        "blocked-missing-or-unreviewed": 3
      },
      "blockerClassCounts": {
        "system-runtime": 1,
        "input-custody": 1,
        "build-artifact": 1
      },
      "dependencyItems": [
        {
          "contractId": "orekit-propagation-v1",
          "probeId": "java-runtime",
          "dependencyState": "blocked-missing-or-unreviewed",
          "blockerClass": "system-runtime",
          "kind": "setup-action",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "setupAction": "Install a reviewed Java runtime compatible with the Orekit sidecar build and record `java -version` output.",
          "verificationCommand": "java -version",
          "custodyNote": "Record Java vendor/version, Gradle build output, Orekit dependency version, sidecar jar hash, and OREKIT_DATA_PATH hash.",
          "evidenceBoundary": "A setup action is an acquisition contract only. It cannot promote runtime, trajectory, resource, or customer claims until the dependency is installed, hashed, reviewed, and the sidecar artifact passes intake.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-a9fffadea7c8c755e704757362c5b8790e15f26701a75b6622b4c5da603cffac"
        },
        {
          "contractId": "orekit-propagation-v1",
          "probeId": "orekit-data-path",
          "dependencyState": "blocked-missing-or-unreviewed",
          "blockerClass": "input-custody",
          "kind": "setup-action",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "setupAction": "Set OREKIT_DATA_PATH to a reviewed Orekit data archive or directory with time-scale, Earth orientation, and ephemeris data.",
          "verificationCommand": "test -e \"$OREKIT_DATA_PATH\"",
          "custodyNote": "Record archive/directory hash, data-source notes, coverage date, and any redistribution/license constraints.",
          "evidenceBoundary": "A setup action is an acquisition contract only. It cannot promote runtime, trajectory, resource, or customer claims until the dependency is installed, hashed, reviewed, and the sidecar artifact passes intake.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-ae6bd583bd385a5c290ad9c97deb2b2ea0c6a24255f906f69cd7bb9be6bdc93e"
        },
        {
          "contractId": "orekit-propagation-v1",
          "probeId": "orekit-sidecar-jar",
          "dependencyState": "blocked-missing-or-unreviewed",
          "blockerClass": "build-artifact",
          "kind": "setup-action",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "setupAction": "Build the Orekit sidecar jar from sidecars/orekit after Java/Gradle dependencies are reviewed.",
          "verificationCommand": "test -f \"$OREKIT_SIDECAR_JAR\"",
          "custodyNote": "Record build command, source tree hash, dependency lock/version output, jar hash, and reviewer approval.",
          "evidenceBoundary": "A setup action is an acquisition contract only. It cannot promote runtime, trajectory, resource, or customer claims until the dependency is installed, hashed, reviewed, and the sidecar artifact passes intake.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-fd8755a9dc6b40ba653411ef96b5a3b2ae53603dffcab8484703f886f3d169a1"
        }
      ],
      "acquisitionPriority": 1,
      "acquisitionState": "blocked-dependency-custody-required",
      "nextAction": "Close 3 dependency custody item(s), rerun npm run science:sidecar:runtime-preflight:capture, then regenerate science evidence.",
      "evidenceBoundary": "Dependency custody records make runtime setup reproducible. They are not model outputs and cannot promote scenario, trajectory, resource, economics, customer, or commercial claims.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "dependencyRecordHash": "sha256-b224d3c3c4f46729578a8856efd2899365989a83eb346c4764a0f6d5dd7c1aed"
    },
    {
      "contractId": "gmat-transfer-v1",
      "tool": "NASA GMAT",
      "domain": "mission-design-transfer",
      "sourceIds": [
        "gmat"
      ],
      "sourceRefs": [
        {
          "sourceId": "gmat",
          "title": "General Mission Analysis Tool",
          "organization": "NASA",
          "type": "official open-source mission analysis tool",
          "url": "https://software.nasa.gov/software/GSC-17177-1",
          "trust": "primary",
          "supports": "Trajectory validation, transfers, optimization, and mission design checks."
        }
      ],
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-runtime",
        "blockedProbeIds": [
          "gmat-executable"
        ],
        "passedProbeIds": [
          "gmat-worker-implementation"
        ]
      },
      "installEvidenceRequired": [
        "GMAT version",
        "GMAT script hash",
        "platform and executable hash"
      ],
      "runSpecHash": "sha256-0557d81b6167b827573059307a15c3621f69f6b35008f5bdef748f9280fee3d8",
      "requiredOutputPath": "artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "commandTemplate": "python sidecars/gmat/run_gmat_transfer.py --scenario <scenarioId> --manifest <gmat-script-manifest.json> --report <reviewed-gmat-run-report.json> --out artifacts/sidecars/gmat/gmat-transfer-v1.json",
      "dependencyCount": 2,
      "passedDependencyCount": 1,
      "missingDependencyCount": 1,
      "dependencyStateCounts": {
        "present-in-current-preflight": 1,
        "blocked-missing-or-unreviewed": 1
      },
      "blockerClassCounts": {
        "external-application": 1
      },
      "dependencyItems": [
        {
          "contractId": "gmat-transfer-v1",
          "probeId": "gmat-worker-implementation",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm gmat-worker-implementation remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-bd12ee179ce4358513a284670095a60b9d847287482d7b4f8a0feac66ba367ae"
        },
        {
          "contractId": "gmat-transfer-v1",
          "probeId": "gmat-executable",
          "dependencyState": "blocked-missing-or-unreviewed",
          "blockerClass": "external-application",
          "kind": "setup-action",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "setupAction": "Install NASA GMAT, set GMAT_BIN to the tested executable path, and record the executable/version evidence.",
          "verificationCommand": "$GMAT_BIN --help",
          "custodyNote": "Record GMAT version, script hash, force-model assumptions, run logs, and output manifest hash before sidecar intake.",
          "evidenceBoundary": "A setup action is an acquisition contract only. It cannot promote runtime, trajectory, resource, or customer claims until the dependency is installed, hashed, reviewed, and the sidecar artifact passes intake.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-612c53ea607da35a4ef32013d4690a81ee032402f2d477b9ec82009f401f0317"
        }
      ],
      "acquisitionPriority": 2,
      "acquisitionState": "blocked-dependency-custody-required",
      "nextAction": "Close 1 dependency custody item(s), rerun npm run science:sidecar:runtime-preflight:capture, then regenerate science evidence.",
      "evidenceBoundary": "Dependency custody records make runtime setup reproducible. They are not model outputs and cannot promote scenario, trajectory, resource, economics, customer, or commercial claims.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "dependencyRecordHash": "sha256-212712722f5d0d9bf9017219e52d6c071b550485fd1f371ea5a15ae6b03c39de"
    },
    {
      "contractId": "tudat-transfer-v1",
      "tool": "Tudat",
      "domain": "cross-tool-trajectory-validation",
      "sourceIds": [
        "tudat"
      ],
      "sourceRefs": [
        {
          "sourceId": "tudat",
          "title": "Tudat Space / TudatPy",
          "organization": "TU Delft Astrodynamics Toolbox community",
          "type": "open-source astrodynamics toolkit",
          "url": "https://docs.tudat.space/en/latest/",
          "trust": "open-source",
          "supports": "Cross-tool propagation, estimation, mission design, and trajectory optimization checks."
        }
      ],
      "readinessState": "blocked-runtime-prerequisites",
      "reproducibilityState": "no-promoted-artifact-runtime-blocked",
      "latestPreflightCanReproduce": false,
      "bestPreflightCanReproduce": false,
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "blocked-missing-runtime",
        "blockedProbeIds": [
          "python-module-tudatpy"
        ],
        "passedProbeIds": [
          "python-runtime",
          "tudat-worker-implementation"
        ]
      },
      "installEvidenceRequired": [
        "TudatPy version",
        "Python environment lock hash",
        "SPICE/body settings hashes"
      ],
      "runSpecHash": "sha256-f67dfda77ada00ef1724aa13e103ecd7be2d0e9e02418042971bc39a22369e39",
      "requiredOutputPath": "artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "commandTemplate": "python sidecars/tudat/run_tudat_transfer.py --scenario <scenarioId> --settings <bodySettings.json> --report <reviewed-tudat-run-report.json> --out artifacts/sidecars/tudat/tudat-transfer-v1.json",
      "dependencyCount": 3,
      "passedDependencyCount": 2,
      "missingDependencyCount": 1,
      "dependencyStateCounts": {
        "present-in-current-preflight": 2,
        "blocked-missing-or-unreviewed": 1
      },
      "blockerClassCounts": {
        "python-package": 1
      },
      "dependencyItems": [
        {
          "contractId": "tudat-transfer-v1",
          "probeId": "python-runtime",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm python-runtime remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-1a80112c0b4dd2cb83938392f321681ad4eaa02e79a24d58341d127d8bf90413"
        },
        {
          "contractId": "tudat-transfer-v1",
          "probeId": "tudat-worker-implementation",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm tudat-worker-implementation remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-b4df9ef3d573d76ae964c41c7aae2f5d0484af952c930bd0c60fc93b8a5feeb1"
        },
        {
          "contractId": "tudat-transfer-v1",
          "probeId": "python-module-tudatpy",
          "dependencyState": "blocked-missing-or-unreviewed",
          "blockerClass": "python-package",
          "kind": "setup-action",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "setupAction": "Install TudatPy in a reviewed virtual environment using sidecars/tudat/requirements.txt.",
          "verificationCommand": "python -c \"import tudatpy; import importlib.metadata as m; print(m.version('tudatpy'))\"",
          "custodyNote": "Record TudatPy version, environment lock or requirements hash, body settings hash, and cross-tool comparison plan.",
          "evidenceBoundary": "A setup action is an acquisition contract only. It cannot promote runtime, trajectory, resource, or customer claims until the dependency is installed, hashed, reviewed, and the sidecar artifact passes intake.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-288d7caa45b2ac0e98a680625211191598a34312181084522d3dd178d420d992"
        }
      ],
      "acquisitionPriority": 2,
      "acquisitionState": "blocked-dependency-custody-required",
      "nextAction": "Close 1 dependency custody item(s), rerun npm run science:sidecar:runtime-preflight:capture, then regenerate science evidence.",
      "evidenceBoundary": "Dependency custody records make runtime setup reproducible. They are not model outputs and cannot promote scenario, trajectory, resource, economics, customer, or commercial claims.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "dependencyRecordHash": "sha256-9e5974baf30c550bba2f6be4f2880226c58e3da5bde316ae08a836a7a326b071"
    },
    {
      "contractId": "openmdao-dymos-optimization-v1",
      "tool": "OpenMDAO/Dymos",
      "domain": "optimization-and-sensitivity",
      "sourceIds": [
        "openmdao",
        "dymos"
      ],
      "sourceRefs": [
        {
          "sourceId": "openmdao",
          "title": "OpenMDAO",
          "organization": "NASA",
          "type": "open-source optimization framework",
          "url": "https://openmdao.org/",
          "trust": "primary",
          "supports": "Future multidisciplinary optimization and sensitivity analysis."
        },
        {
          "sourceId": "dymos",
          "title": "Dymos",
          "organization": "OpenMDAO project",
          "type": "open-source optimal-control library",
          "url": "https://openmdao.github.io/dymos/",
          "trust": "open-source",
          "supports": "Trajectory/logistics optimal control, multidisciplinary sensitivity, and Pareto studies."
        }
      ],
      "readinessState": "runtime-artifact-promoted",
      "reproducibilityState": "promoted-artifact-currently-reproducible",
      "latestPreflightCanReproduce": true,
      "bestPreflightCanReproduce": true,
      "latestPreflight": {
        "reportPath": "evidence/sidecar-runtime-preflight/current-local-runtime-preflight-report.json",
        "reportHash": "sha256-ccd5f2e113cbd1efc06932a288e60a2b22286d9127d91ad53de5e92fe5eb0247",
        "generatedAt": "2026-07-01T09:10:46.037Z",
        "preflightState": "ready-to-run-runtime-worker",
        "blockedProbeIds": [],
        "passedProbeIds": [
          "python-runtime",
          "python-module-openmdao",
          "python-module-dymos",
          "openmdao-dymos-worker-script",
          "openmdao-dymos-problem-file"
        ]
      },
      "installEvidenceRequired": [
        "OpenMDAO version",
        "Dymos version",
        "optimizer package and seed"
      ],
      "runSpecHash": "sha256-282d8d68479110e12375b4ee39ea99c50bc9b58767b28570ab5c3c5b7a92caa0",
      "requiredOutputPath": "artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "commandTemplate": "python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json",
      "dependencyCount": 5,
      "passedDependencyCount": 5,
      "missingDependencyCount": 0,
      "dependencyStateCounts": {
        "present-in-current-preflight": 5
      },
      "blockerClassCounts": {},
      "dependencyItems": [
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "probeId": "python-runtime",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm python-runtime remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-35b7d85dc0d05a365718d236b084b24e1e7923938018ec2c68ec39d7ffa18e1e"
        },
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "probeId": "python-module-openmdao",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm python-module-openmdao remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-f97e317414f0a1b20e942b9f9d936fcfcd80b9a5a727713a47b621d7aa7f6e38"
        },
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "probeId": "python-module-dymos",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm python-module-dymos remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-f96d4fa632e3f0f116e131fbdd22bdba5d4b8507ad58c7f5299119c4b7c5f755"
        },
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "probeId": "openmdao-dymos-worker-script",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm openmdao-dymos-worker-script remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-e589d62ec903fe46b1f92dbbd2245b3a9cb597f3b827a85ce9272bd38625cccf"
        },
        {
          "contractId": "openmdao-dymos-optimization-v1",
          "probeId": "openmdao-dymos-problem-file",
          "dependencyState": "present-in-current-preflight",
          "blockerClass": "passed-prerequisite",
          "kind": "preflight-probe",
          "command": null,
          "commandLabel": null,
          "moduleName": null,
          "packageName": null,
          "version": null,
          "envVar": null,
          "path": null,
          "verificationCommand": "Rerun npm run science:sidecar:runtime-preflight and confirm openmdao-dymos-problem-file remains in passedProbeIds.",
          "custodyNote": "Current preflight saw this prerequisite. Preserve executable path, version output, source URL, environment hash, and reviewer approval before using it for runtime evidence.",
          "evidenceBoundary": "A passed prerequisite is operational evidence only. It is not a runtime artifact, trajectory result, or customer proof.",
          "customerUseAllowed": false,
          "commercialUseAllowed": false,
          "dependencyHash": "sha256-61c721cb5ee2dc5ab1a76241df62e3b7c8286b9711a0372bd44f3cf1bb5dd243"
        }
      ],
      "acquisitionPriority": 4,
      "acquisitionState": "ready-for-runtime-artifact-generation",
      "nextAction": "Run python sidecars/openmdao_dymos/run_optimization.py --problem artifacts/sidecars/openmdao_dymos/moon-logistics-beta.problem.json --out artifacts/sidecars/openmdao_dymos/openmdao-dymos-optimization-v1.json and validate the output through sidecar intake.",
      "evidenceBoundary": "Dependency custody records make runtime setup reproducible. They are not model outputs and cannot promote scenario, trajectory, resource, economics, customer, or commercial claims.",
      "customerUseAllowed": false,
      "commercialUseAllowed": false,
      "dependencyRecordHash": "sha256-4e880e99aad76532ccd1bf57d7fa2350b5e800ffc5392c5ad382bf61462d7239"
    }
  ],
  "releaseImpact": "This ledger reduces runtime setup ambiguity, but public beta and customer proof remain blocked until runtime artifacts are generated, validated, reviewed, and current-shell reproducible.",
  "ledgerHash": "sha256-0c9052094b6255deb28219335af3145a130567d90f111695be765341252c44d1",
  "markdownPath": "public/runtime-dependency-custody-ledger.md",
  "markdownHash": "sha256-7ce1c0b6729196c04db5c14dfb8d6d154209c4d4bf24ac3d12b6b79203d9af9a"
}
;
